'use client'
import Image from 'next/image'

function StateAppDownloadSection({
  eyebrow,
  title,
  description,
  imageUrl,
  appStoreUrl,
  googlePlayUrl,
}) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-12 md:px-6 md:py-16">
      <div className="flex flex-col md:flex-row gap-6 md:gap-8">
        {/* Image */}
        {imageUrl && (
          <div className="relative w-full aspect-4/3 md:aspect-auto md:w-[175px] md:h-[140px] shrink-0 bg-gray-300 rounded-sm overflow-hidden">
            <Image
              src={imageUrl}
              alt={title || 'App download'}
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, 175px"
            />
          </div>
        )}

        {/* Content */}
        <div className="w-full md:w-2/3 flex flex-col gap-2.5">
          {/* Eyebrow */}
          {eyebrow && (
            <p className="m-0 text-sm font-semibold uppercase tracking-wider text-gray-500">
              {eyebrow}
            </p>
          )}

          {/* Title */}
          {title && (
            <h2 className="m-0 text-xl md:text-3xl font-bold text-gray-900 leading-snug">
              {title}
            </h2>
          )}

          {/* Description */}
          {description && (
            <p className="m-0 text-sm text-gray-700 leading-relaxed">{description}</p>
          )}

          {/* App Store Buttons */}
          <div className="flex gap-3 mt-1.5">
            {appStoreUrl && (
              <a
                href={appStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block no-underline"
              >
                <div className="bg-black text-white h-11 px-4 rounded-sm flex items-center gap-2 hover:bg-gray-800 transition-colors">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white" className="shrink-0">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <div className="text-left leading-tight">
                    <div className="text-[10px] whitespace-nowrap">Download on the</div>
                    <div className="text-sm font-semibold whitespace-nowrap">App Store</div>
                  </div>
                </div>
              </a>
            )}

            {googlePlayUrl && (
              <a
                href={googlePlayUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block no-underline"
              >
                <div className="bg-black text-white h-11 px-4 rounded-sm flex items-center gap-2 hover:bg-gray-800 transition-colors">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white" className="shrink-0">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                  </svg>
                  <div className="text-left leading-tight">
                    <div className="text-[10px] whitespace-nowrap">GET IT ON</div>
                    <div className="text-sm font-semibold whitespace-nowrap">Google Play</div>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export { StateAppDownloadSection }
export default StateAppDownloadSection
